import Autocomplete from './autocomplete';
import './styles.scss';

class Search {
  constructor(element) {
    this.element = element;
    this.isOpen = false;
    this.isIconVersion = element.hasAttribute('data-icon-search');
    this.isAutocompleteEnabled = element.hasAttribute(
      'data-search-autocomplete'
    );
    this.isSugestionsEnabled = element.hasAttribute('data-search-suggestions');
    this.inputField = element.querySelector('.search-block__input');
    this.resetButton = element.querySelector('.search-block__reset');
    this.icon = element.querySelector('.search-block__icon');
    this.resultsBlock = element.querySelector('.search-block__results');

    if (this.isAutocompleteEnabled) {
      this.autocomplete = new Autocomplete(this);
    }
  }

  init() {
    this.registerEffects();
  }

  registerEffects() {
    if (this.isIconVersion) {
      this.icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        this.openSearch();
      });

      this.resetButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (this.isActiveReset) {
          this.clearSearch();

          return;
        }

        this.closeSearch();
      });

      this.inputField.addEventListener('input', () => {
        if (this.inputField.value.length > 2) {
          this.showReset();
          return;
        }

        this.hideReset();
        if (this.isSugestionsEnabled) {
          this.changeState('suggestions');
        }
      });
    } else {
      this.inputField.addEventListener('focus', (e) => {
        e.preventDefault();

        if (this.isSugestionsEnabled) {
          this.changeState('suggestions');
        }
      });
    }

    if (this.isAutocompleteEnabled) {
      this.autocomplete.registerEffects();
    }
  }

  documentEffects(event) {
    if (event.target.closest('.search-block')) {
      return;
    }

    this.closeSearch();
  }

  changeState(state) {
    this.element.dataset.boxState = state;
  }

  openSearch() {
    this.element.classList.add('search-block--show');
    this.inputField.focus();
    if (this.isSugestionsEnabled) {
      this.changeState('suggestions');
    }
    this.isOpen = true;
  }

  clearSearch() {
    this.inputField.value = '';
    this.hideReset();

    if (this.isSugestionsEnabled) {
      this.changeState('suggestions');
      return;
    }

    this.changeState('hidden');
  }

  closeSearch() {
    this.element.classList.remove('search-block--show');
    this.clearSearch();
    this.changeState('hidden');
    this.isOpen = false;
  }

  showReset() {
    this.resetButton.classList.add('search-block__reset--active');
    this.resetButton.setAttribute('type', 'reset');
    this.resetButton.setAttribute('aria-label', 'Reset search form');
  }

  hideReset() {
    this.resetButton.classList.remove('search-block__reset--active');
    this.resetButton.setAttribute('type', 'button');
    this.resetButton.setAttribute('aria-label', 'Close search form');
  }

  get isActiveReset() {
    return this.resetButton.classList.contains('search-block__reset--active');
  }
}

const searches = [];

document.querySelectorAll('.search-block').forEach((module) => {
  const search = new Search(module);

  search.init();
  searches.push(search);
});

window.addEventListener('click', (e) => {
  searches.forEach((search) => {
    search.documentEffects(e);
  });
});
